import $ from 'jquery';
import readCourseAndLavelFromTable from "./table_course";

readCourseAndLavelFromTable();










